import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UNPAID_ROUTE } from '../shared/constants/routes';
import { AuthGuard } from '../guards/auth.guard';
import { UnpaidComponent } from './unpaid/unpaid.component';

const routes: Routes = [
  {
    path: UNPAID_ROUTE,
    component: UnpaidComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UnpaidRoutingModule {}
